var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefusalStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 33,
    viewBox: "0 0 87 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4896 33.0003H0.333008C1.25671 29.8227 5.77448 23.4674 16.4559 23.4674C29.8076 23.4674 33.0826 16.3177 42.9075 6.41815C50.7674 -1.50151 75.2372 1.0406 86.4896 3.30162V33.0003Z",
    fill: "url(#paint0_linear_3854_7676)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1425 3.26235C76.7735 1.38505 56.4934 -0.87976 47.3399 3.62576C35.8982 9.25766 35.8982 21.6114 20.4766 23.0648C13.5694 23.7158 7.7912 23.6099 2.07031 30.8768",
    stroke: "#E34850",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3854_7676",
    x1: 105.905,
    y1: 1.03906,
    x2: 105.905,
    y2: 33.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E34850",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E34850",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefusalStatus);
export default __webpack_public_path__ + "static/media/refusal-status.9ac0afa1c89e6418a2b6f4498b5a08a6.svg";
export { ForwardRef as ReactComponent };